<template src="./u-input.html" />
<script src="./u-input.ts" lang="ts"></script>
<style src="./u-input.scss" scoped lang="scss"></style>
